import { BankCardAuthStatus } from 'components/BankCardSelect';

export interface PlaidBankCardItem {
    /**
     * fund_card, bank_card_relation的id
     */
    id: number;
    /**
     * 当前银行卡唯一id
     */
    account_id: string;
    /**
     * 银行账号（已脱敏）
     */
    account: string;
    /**
     * 银行卡类型
     */
    subtype: string;
    /**
     * 银行id, 可通过银行id判断是哪家银行
     */
    institution_id: string;
    /**
     * The last 2-4 alphanumeric characters of an account official account number
     * plaid 特殊信息
     */
    mask: string;
    profile_id: number;
    /**
     * 特殊编号，如41100079-Chase-S-1111
     */
    instruction_name: string;
    status: 'AVAILABLE' | 'ERROR' | 'VERIFIED';
    /**
     * 银行名称， 如Chase， Capital one
     */
    institution_name: string;
    /**
     * Fund or Bank
     * Fund表示plaid认证银行卡
     */
    id_source?: 'Fund' | 'Bank';
    bank_card_status: BankCardAuthStatus;
    /**
     * 银行账户是否需要认证
     */
    bank_card_need_auth: boolean;
    /**
     * PlaidAccountType, 典型的如depository
     */
    type: string;
    plaid_account_id: string;
    /**
     * 老虎开户的资金号
     */
    ib_account: string;
    // 当 id_source == Fund，且存在过期日期才会返回下面两个参数
    expiration_at?: number;
    /** 当临近过期，比如 7 天内，才会返回将要过期的天数 */
    days_to_expire?: number;
}
